var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"header"}},[_c('van-nav-bar',{attrs:{"border":false},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{attrs:{"name":"arrow-left","size":"22","color":"#61646A"},on:{"click":_vm.handleBack}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }